import { gql } from "@apollo/client";

export const REMOVE_INDICACION = gql`
    mutation deleteIndicacionRI($idIndicacionRI: Int!)
    {
        deleteIndicacionRI(
            idIndicacionRI: $idIndicacionRI
        )
    }
`;